function ptiAfterLoadHook() {
  const switchWrapper = document.querySelector(".pti-info-wrapper");
  const popup = document.querySelector("#pti-popup");

  if (!switchWrapper || !popup) return;

  let helpIcon = switchWrapper.querySelector(".pti-help-icon");

  if (!helpIcon) {
    helpIcon = document.createElement("span");
    helpIcon.className = "pti-help-icon";
    helpIcon.innerHTML = "?";
    switchWrapper.appendChild(helpIcon);
  }

  helpIcon.onclick = function (e) {
    e.preventDefault();
    e.stopPropagation();
    popup.classList.toggle("pti-popup-active");
  };

  document.querySelector(".pti-popup-close").onclick = function (e) {
    e.preventDefault();
    e.stopPropagation();
    popup.classList.remove("pti-popup-active");
  };

  document.addEventListener("click", function (e) {
    if (!switchWrapper.contains(e.target) && !popup.contains(e.target)) {
      popup.classList.remove("pti-popup-active");
    }
  });
}